<template>
  <b-overlay :show="show" rounded="sm" no-wrap :z-index="11">
    <template #overlay>
      <div class="text-center my-2">
        <font-awesome-icon icon="spinner" :size="size" pulse />
        <div><strong>{{message}}...</strong></div>
      </div>
    </template>
  </b-overlay>
</template>

<script>
export default {
  name: 'SavingSpinner',
  props: {
    show: {
      default: false,
    },
    size: {
      default: '2x',
    },
    message: {
      default: 'Saving',
    },
  },
};
</script>
